export default __webpack_public_path__ + "static/media/mockup26.b938619d.jpg";